import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { doc, getDoc } from "firebase/firestore";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "Home" */ "../views/Home.vue")
  },
  {
    path: "/affiliates",
    name: "Affiliates",
    component: () =>
      import(/* webpackChunkName: "Affiliates" */ "../views/Affiliates.vue")
    // acessível sem autenticação
  },
  {
    path: "/admin",
    name: "AdminPage",
    component: () =>
      import(/* webpackChunkName: "AdminPage" */ "../views/AdminPage.vue"),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: "/admin/affiliates",
    name: "AffiliatesAdmin",
    component: () =>
      import(
        /* webpackChunkName: "AffiliatesAdmin" */ "../views/AffiliatesAdmin.vue"
      ),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: "/matches",
    name: "Matches",
    component: () =>
      import(/* webpackChunkName: "Home" */ "../views/Matches.vue")
  },
  {
    path: "/teams",
    name: "Teams",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Teams" */ "../views/Teams.vue"),
    children: [
      {
        path: "/create",
        name: "Create Team",
        component: () =>
          import(/* webpackChunkName: "Teams" */ "../views/Team.vue"),
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/mymatches",
    name: "My Matches",
    component: () =>
      import(/* webpackChunkName: "Home" */ "../views/Matches.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/myteams",
    name: "My Teams",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Teams" */ "../views/Teams.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/myseasons",
    name: "My Seasons",
    component: () =>
      import(/* webpackChunkName: "Season" */ "../views/Seasons.vue"),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: "/myservers",
    name: "My Servers",
    component: () =>
      import(/* webpackChunkName: "Server" */ "../views/Servers.vue"),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: "/teams/:id",
    name: "Team",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Team" */ "../views/Team.vue")
  },
  {
    path: "/match/create",
    name: "New Match",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Match" */ "../views/CreateMatch.vue"),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
    //children: [{ path: "/create", component: MatchCreate }]
  },
  {
    path: "/lobby/create",
    name: "New Match Lobby",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Match" */ "../views/CreateMatchPage.vue"),
    meta: {
      requiresAuth: true,
      isAdmin: false
    }
    //children: [{ path: "/create", component: MatchCreate }]
  },
  {
    path: "/lobby/:id",
    name: "Match Lobby",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Match" */ "../views/CurrentLobby.vue"),
    meta: {
      requiresAuth: true,
      isAdmin: false
    }
    //children: [{ path: "/create", component: MatchCreate }]
  },
  {
    path: "/match/:id",
    name: "Match",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Match" */ "../views/Match.vue")
    //children: [{ path: "/create", component: MatchCreate }]
  },
  {
    path: "/user/:id",
    name: "User",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "User" */ "../views/User.vue")
    //children: [{ path: "/create", component: MatchCreate }]
  },
  {
    path: "/user",
    name: "My User",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "User" */ "../views/User.vue")
    //children: [{ path: "/create", component: MatchCreate }]
  },
  {
    path: "/seasons",
    name: "Seasons",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Season" */ "../views/Seasons.vue")
  },
  {
    path: "/season/:id",
    name: "Season",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Season" */ "../views/Season.vue")
  },
  {
    path: "/servers",
    name: "Servers",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Server" */ "../views/Servers.vue"),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: "/metrics",
    name: "Metrics",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Metrics" */ "../views/Metrics.vue"),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: "/leaderboard",
    name: "Leaderboard",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "Leaderboards" */ "../views/PlayerLeaderboard.vue"
      )
  },
  {
    path: "/ranking",
    name: "Ranking",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Leaderboards" */ "../views/Ranking.vue")
  },
  // TODO: Fix this broken route? Child doesn't load...
  {
    path: "/FAQ",
    name: "FAQ",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Leaderboards" */ "../views/FAQ.vue")
  },
  {
    path: "/leaderboard/teams",
    name: "TeamBoard",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "Leaderboards" */ "../views/TeamLeaderboard.vue"
      )
  },
  {
    path: "/leaderboard/:seasonid",
    name: "SeasonPlayerBoard",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Match" */ "../views/PlayerLeaderboard.vue")
    //children: [{ path: "/create", component: MatchCreate }]
  },
  {
    path: "/leaderboard/teams/:seasonid",
    name: "SeasonTeamBoard",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "Leaderboards" */ "../views/TeamLeaderboard.vue"
      )
  },
  {
    path: "/lobby",
    name: "Lobby",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Leaderboards" */ "../views/Lobby.vue")
  },
  {
    path: "/skins",
    name: "SkinChanger",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Leaderboards" */ "../views/SkinChanger.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/inventory",
    name: "Inventory",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Leaderboards" */ "../views/Inventory.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/admin/coupons",
    name: "AdminCoupons",
    // route level code-splitting
    // this generates a separate chunk (admin-coupons.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "AdminCoupons" */ "../views/AdminCoupons.vue"
      ),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: "/admin/coupons/:couponId/report",
    name: "CouponReport",
    // route level code-splitting
    // this generates a separate chunk (coupon-report.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "CouponReport" */ "../views/CouponReport.vue"
      ),
    meta: {
      requiresAuth: true,
      isAdmin: true
    },
    props: true
  },
  {
    path: "/plans",
    name: "BuyVip",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Leaderboards" */ "../views/BuyVip.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/aluguel-servidores",
    name: "ServerRental",
    // route level code-splitting
    // this generates a separate chunk (server-rental.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "ServerRental" */ "../views/ServerRental.vue"
      ),
    meta: {
      title: "Aluguel de Servidores CS2 - Clutch Arena",
      description:
        "Alugue servidores de Counter-Strike 2 com a melhor performance e preços competitivos. Servidores dedicados para treinos, scrims e torneios.",
      keywords:
        "aluguel servidor cs2, servidor counter strike 2, servidor dedicado cs2, servidor de jogo"
    }
  },
  {
    path: "/live/matches",
    name: "CurrentMatches",
    // route level code-splitting
    // this generates a separate chunk (teams.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "Leaderboards" */ "../views/CurrentMatchs.vue"
      )
  },
  {
    path: "/discord",
    beforeEnter() {
      window.location.href = "https://discord.gg/thV7RsDRHF";
    }
  },
  {
    path: "/whatsapp",
    beforeEnter() {
      window.location.href = "https://chat.whatsapp.com/FQ2fzX0RKeMCv6Hhly9Esg";
    }
  },
  {
    path: "/rules",
    name: "Rules",
    component: () =>
      import(/* webpackChunkName: "Legal" */ "../views/Rules.vue")
  },
  {
    path: "/support",
    name: "Support",
    component: () =>
      import(/* webpackChunkName: "Legal" */ "../views/Support.vue")
  },
  {
    path: "/server-status",
    name: "ServerStatus",
    component: () =>
      import(/* webpackChunkName: "Legal" */ "../views/ServerStatus.vue")
  },
  {
    path: "/tournaments",
    name: "Tournaments",
    component: () =>
      import(/* webpackChunkName: "Legal" */ "../views/Tournaments.vue")
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () =>
      import(/* webpackChunkName: "Legal" */ "../views/Privacy.vue")
  },
  {
    path: "/terms",
    name: "Terms",
    component: () =>
      import(/* webpackChunkName: "Legal" */ "../views/Terms.vue")
  },
  {
    path: "/cookies",
    name: "Cookies",
    component: () =>
      import(/* webpackChunkName: "Legal" */ "../views/Cookies.vue")
  },
  {
    path: "/admin/maintenance",
    name: "AdminMaintenance",
    component: () =>
      import(
        /* webpackChunkName: "AdminMaintenance" */ "../views/AdminMaintenance.vue"
      ),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: "/admin/superpowers",
    name: "AdminSuperPowers",
    component: () =>
      import(
        /* webpackChunkName: "AdminSuperPowers" */ "../views/AdminSuperPowers.vue"
      ),
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () =>
      import(/* webpackChunkName: "Maintenance" */ "../views/Maintenance.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  // Verifica se está em modo de manutenção (exceto para admins e a própria página de manutenção)
  if (to.path !== "/maintenance" && to.path !== "/admin/maintenance") {
    try {
      // Obtém o firestore através do Vue instance quando disponível
      // Isso evita problemas de importação durante o build
      const firestore = router.app && router.app.$firestore;
      
      if (firestore) {
        const maintenanceRef = doc(firestore, "system", "maintenance");
        const maintenanceDoc = await getDoc(maintenanceRef);

        if (maintenanceDoc.exists()) {
          const maintenanceData = maintenanceDoc.data();
          if (maintenanceData.enabled) {
            // Verifica se o usuário é admin antes de redirecionar
            let isAuthenticated = store.getters.isAuthenticated;
            if (!isAuthenticated) {
              try {
                await store.dispatch("fetchUser");
              } catch (error) {
                console.error("Failed to fetch user data:", error);
              }
            }
            const isAdmin = store.getters.isAdmin || store.getters.isSuperAdmin;
            isAuthenticated = store.getters.isAuthenticated;

            // Se não for admin, redireciona para página de manutenção
            if (!isAdmin) {
              return next({ path: "/maintenance" });
            }
          }
        }
      }
      // Se o firestore não estiver disponível ainda, continua normalmente
      // Isso pode acontecer durante a inicialização
    } catch (error) {
      console.error("Erro ao verificar modo de manutenção:", error);
      // Em caso de erro, continua normalmente
    }
  }

  let isAuthenticated = store.getters.isAuthenticated;

  if (!isAuthenticated) {
    try {
      await store.dispatch("fetchUser");
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  }
  const isAdmin = store.getters.isAdmin || store.getters.isSuperAdmin;
  isAuthenticated = store.getters.isAuthenticated;

  console.log("isAuthenticated", isAuthenticated);
  console.log("isAdmin", isAdmin);

  const apiUrl = process.env?.VUE_APP_G5V_API_URL || "/api";

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      window.location.href = `${apiUrl}/auth/steam`;
    } else if (to.matched.some(record => record.meta.isAdmin) && !isAdmin) {
      next({
        path: "/"
        //query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
